// removed by extract-text-webpack-plugin
module.exports = {"avatar":"qempo_avatar_avatar-1xegr7H","small":"qempo_avatar_small-2784Vtj","medium":"qempo_avatar_medium-2FMEJgs","large":"qempo_avatar_large-1AtdiiY","huge":"qempo_avatar_huge-2_D170M"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/avatar.scss
// module id = 109
// module chunks = 0